import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectCheckboxList$ = new BehaviorSubject({});

export const behaviorSubjectCheckboxList = behaviorSubjectCheckboxList$.asObservable();
